import { Button } from '@/components/ui/Button'
import { copy } from '@/lib/copy'

interface NativeLanguageChangeDialogProps {
  languageLabel: string
  onConfirm: () => void
  onCancel: () => void
}

export function NativeLanguageChangeDialog({
  languageLabel,
  onConfirm,
  onCancel,
}: NativeLanguageChangeDialogProps) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      data-testid="native-language-change-dialog"
    >
      <div className="w-full max-w-md rounded-xl border bg-card p-6 shadow-2xl">
        <h2 className="text-lg font-semibold">{copy.settings.nativeLanguageChangeTitle}</h2>
        <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
          {copy.settings.nativeLanguageChangeBody(languageLabel)}
        </p>
        <div className="mt-5 flex flex-col gap-2 sm:flex-row-reverse">
          <Button className="flex-1" onClick={onConfirm} data-testid="native-language-change-confirm">
            {copy.settings.nativeLanguageChangeConfirm}
          </Button>
          <Button
            className="flex-1 bg-secondary text-secondary-foreground hover:bg-secondary/80"
            onClick={onCancel}
            data-testid="native-language-change-cancel"
          >
            {copy.settings.nativeLanguageChangeCancel}
          </Button>
        </div>
      </div>
    </div>
  )
}
